import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

type StyledReportingPeriodProps = {
  $extraMarginLeft?: boolean;
  $fontSize?: string;
  $green?: boolean;
  $strong?: boolean;
  $white?: boolean;
};

function greenStyle({ $green = false }: StyledReportingPeriodProps) {
  if ($green) {
    return css`
      strong {
        color: ${Colours.green};
        font-weight: normal;
      }
    `;
  }
}
function whiteStyle({ $white = false }: StyledReportingPeriodProps) {
  if ($white) {
    return css`
      color: ${Colours.white};

      strong {
        color: ${Colours.white};
        font-weight: normal;
      }
    `;
  }
}

function strongStyle({ $strong = false }: StyledReportingPeriodProps) {
  if ($strong) {
    return css`
      strong {
        font-weight: 500;
      }
    `;
  }
}

function hasExtraMarginLeft({ $extraMarginLeft = false }: StyledReportingPeriodProps) {
  if ($extraMarginLeft) {
    return css`
      margin-left: 1rem;
    `;
  }
}

export default styled.span<StyledReportingPeriodProps>`
  display: inline;
  font-size: ${({ $fontSize }) => $fontSize};
  ${greenStyle}
  ${whiteStyle}
  ${strongStyle}
  ${hasExtraMarginLeft}
`;
